'use client';

import { BaseFillFolder } from '@/app/components/icons/BaseFillFolder';
import { SITE, TEXT_2_AUDIO_IMAGE } from '@/app/constants';
import { cn, getAudioImageIndex } from '@/app/utils';
import type { FileItem } from '../types';

const PreviewItem = ({ item, isPrimary = false, count }: { item: FileItem; isPrimary?: boolean; count?: number }) => {
  const name = count && count > 1 ? `${item.name} and ${count - 1} others` : item.name;
  return (
    <div
      className={cn(
        'relative flex items-center gap-x-2 rounded-8 bg-[#2F3237] px-4 py-2 text-system-white shadow-[0px_-4px_4px_0px_rgba(0,0,0,0.10)]',
      )}
    >
      {item.type === 'folder' ? (
        <BaseFillFolder className="size-5 text-blue-400" />
      ) : (
        <div className="flex size-5 items-center justify-center">
          <img
            src={
              item.creationType === 'audio'
                ? TEXT_2_AUDIO_IMAGE[getAudioImageIndex(item.id, TEXT_2_AUDIO_IMAGE.length)].cover[SITE]
                : item.coverUrl
            }
            alt={item.name}
            className="max-h-full max-w-full rounded-2"
          />
        </div>
      )}
      <div className="min-w-0 flex-1">
        <p className="cursor-default truncate font-medium text-sm">{name}</p>
      </div>
      {isPrimary && count && count > 1 && (
        <div className="-right-7 absolute top-0 rounded-full bg-system-blue02 px-4 text-sm">
          {count < 1000 ? count : '999+'}
        </div>
      )}
    </div>
  );
};

// 拖拽预览组件
export function DragPreview({ activeItem, selectedItems }: { activeItem: FileItem; selectedItems: string[] }) {
  const selectedItemsCount = selectedItems.length;

  return (
    <div className="relative w-[252px]">
      {selectedItemsCount > 1 && (
        <>
          <div className="-translate-y-2 absolute top-0 left-0 z-20 w-full translate-x-3">
            <PreviewItem item={activeItem} />
          </div>
          {selectedItemsCount > 2 && (
            <div className="-translate-y-4 absolute top-0 left-0 z-10 w-full translate-x-6">
              <PreviewItem item={activeItem} />
            </div>
          )}
        </>
      )}
      <div className="relative z-30">
        <PreviewItem item={activeItem} isPrimary count={selectedItemsCount} />
      </div>
    </div>
  );
}
